import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Box from '@material-ui/core/Box/Box';
import Checkbox from '@material-ui/core/Checkbox/Checkbox';
import FormControl from '@material-ui/core/FormControl/FormControl';
import InputBase from '@material-ui/core/InputBase/InputBase';
import MenuItem from '@material-ui/core/MenuItem/MenuItem';
import Select from '@material-ui/core/Select/Select';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography/Typography';
import { useState } from 'react';
import NeoToolTip from '../../../../nl-lib/common/ui/NeoToolTip';
import getText from '../../../../nl-lib/i18n/language';
import { printOptionTip } from './ToolTips';
const BootstrapInput = withStyles((theme) => ({
    root: {
        'label + &': {
            marginTop: theme.spacing(0),
        },
    },
    input: {
        borderRadius: 4,
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '0px solid #ced4da',
        fontSize: 16,
        padding: '0px 0px 0px 10px',
        magrin: '0px 0px 0px 0px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
        width: "50px",
        // Use the system font instead of the default Roboto font.
        '&:focus': {
            borderRadius: 4,
            borderColor: '#80bdff',
            boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
        },
    },
}))(InputBase);
const useStyles = makeStyles((theme) => ({
    margin: {
        margin: theme.spacing(0),
    },
}));
function SelectFieldSub(props) {
    const classes = useStyles();
    const { handleChange, color, name, children, value, candidates } = props;
    const [checked, setChecked] = useState(false);
    const onFocusOut = (event) => {
        console.log(event.target.value);
        setChecked(true);
        handleChange(event);
    };
    const onChange = (event) => {
        setChecked(true);
        handleChange(event);
    };
    return (_jsxs(Box, Object.assign({ display: "flex", alignItems: "center", justifyContent: "left" }, { children: [_jsx(Checkbox, { style: { paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 6 }, disabled: true, checked: checked, onChange: handleChange, color: color, name: name }), children, _jsx(FormControl, Object.assign({ className: classes.margin }, { children: _jsx(Select, Object.assign({ style: { paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 6, margin: 0 }, onChange: onChange, variant: "outlined", color: color, name: name, id: name, value: value, input: _jsx(BootstrapInput, {}), onBlur: onFocusOut, label: getText("print_popup_select_page_example"), fullWidth: true }, { children: candidates.map((value, index) => (_jsx(MenuItem, Object.assign({ value: value }, { children: value }), index))) })) }))] })));
}
export function SelectField(props) {
    const { name, tip, showHelp } = props;
    let autoTip = tip;
    // const upper = value.toUpperCase();
    if (autoTip === undefined) {
        autoTip = printOptionTip[name];
    }
    console.log("text filed rendered");
    return (_jsx("div", { children: _jsx(NeoToolTip, Object.assign({ open: showHelp, placement: "left", tip: autoTip, title: undefined }, { children: _jsx(Typography, Object.assign({ variant: "subtitle1", component: "h5" }, { children: _jsx(SelectFieldSub, Object.assign({}, props)) })) })) }));
}
//# sourceMappingURL=SelectField.js.map